import React, { useMemo } from 'react';

// store
import { useStoreValue } from '../../../../../../../../store';
import { startExternalDrag } from '../../../../../../../../store/externalDragStore';

// tools
import getDateFromISOstring from '../../../../../../../../helpers/getDateFromISOstring';

// components
import BadgeTrack from '../../../../../../../../components/BadgeTrack';
import TripleDotsIcon from '../../../../../../../../icons/TripleDotsIcon';
import ButtonIconContextMenu from '../../../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';

const ListOfReferenceItems = () => {
    const cueSheet = useStoreValue('cueSheet');
    const referencesItems = useMemo(() => cueSheet.filter(o => o.cueType === 'REFERENCE'), [cueSheet]);

    return(
        referencesItems.map(item => <li key={`music_ref_${item.id}`}
            style={{ cursor: 'grab' }}
            onMouseDown={(e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                startExternalDrag(item, e.clientX, e.clientY);
            }}
        >
            <div>
                <BadgeTrack>{item.label}</BadgeTrack>
            </div>
            <div className="title">
                <h3>{item.title}</h3>
                <span>{item.timecode}</span>
            </div>
            <div className="meta lastGroup">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                <ButtonIconContextMenu>
                    <TripleDotsIcon/>
                </ButtonIconContextMenu>
            </div>
        </li>)
    )
}

export default ListOfReferenceItems;